import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { countries } from "constants/apiUrls";

const countryListApi = createApi({
  reducerPath: "countryList",
  baseQuery: fetchBaseQuery({ baseUrl: "" }),
  endpoints: (builder) => ({
    countryList: builder.query<PaginatedResonse<CountryType>, void>({
      query: (arg) => {
        const token = localStorage.getItem("token");
        const mandatoryHeaders: any = {
          "bludot-app-name": "business-rewards",
          "Content-Type": "application/json",
        };

        // Add authorization if token exists
        if (token) {
          try {
            mandatoryHeaders.Authorization = `Bearer ${JSON.parse(token)}`;
          } catch (e) {
            // Failed to parse token
          }
        }

        return {
          url: countries,
          headers: mandatoryHeaders,
        };
      },
    }),
  }),
});

export const { useCountryListQuery, useLazyCountryListQuery } = countryListApi;
export default countryListApi;
